import {Component} from '@angular/core';
import {AuthService} from 'gamesis-auth';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';

@Component({
    selector: 'logout',
    template: `
        <ion-button fill='clear' expand='full' type="button" color='primary' *authenticated (click)="logout()">
            <ion-label>Log out</ion-label>
            <ion-icon name="log-out-outline" slot="end"></ion-icon>
        </ion-button>
    `,
    standalone: false
})
export class Logout {

    constructor(private router: Router,
                private authService: AuthService,
                private logger: NGXLogger) {
    }

    logout() {
        this.authService.logout().then(() => {
            this.logger.debug('logged out, redirecting to login page');
            this.router.navigate(['/login']);
        });
    }
}
